import React, { useEffect, useState } from 'react';

const CountDownClock = () => {
  const endTime = new Date();
  endTime.setHours(24, 0, 0);

  const [currentTime, setCurrentTime] = useState<{
    hh: string;
    mm: string;
    ss: string;
  }>({
    hh: '24',
    mm: '00',
    ss: '00',
  });

  const addPrefixZero = (time: number) => {
    const timeStr = time + '';
    return timeStr.length === 1 ? '0' + timeStr : timeStr;
  };

  const getTimeDifference = (start: Date, end: Date) => {
    // Calculate the time difference in milliseconds
    const timeDiff = end.getTime() - start.getTime();

    const totalSeconds = Math.floor(timeDiff / 1000);
    const seconds = totalSeconds % 60;
    const totalMinutes = Math.floor(totalSeconds / 60);
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);

    return {
      hh: addPrefixZero(hours),
      mm: addPrefixZero(minutes),
      ss: addPrefixZero(seconds),
    };
  };

  useEffect(() => {
    const timeout = setInterval(() => {
      const currentTime = new Date();
      setCurrentTime(getTimeDifference(currentTime, endTime));
    }, 1000);

    return () => clearInterval(timeout);
  }, []);

  const decoreUnitText = (unit: string) => {
    return <span style={{ color: 'cyan' }}>{unit}</span>;
  };

  return (
    <div
      style={{
        background: '#fff3',
        color: '#fff',
        padding: '6px',
        marginLeft: '10px',
        borderRadius: 8,
      }}
    >
      {currentTime.hh}
      {decoreUnitText('h')} {currentTime.mm}
      {decoreUnitText('m')} {currentTime.ss}
      {decoreUnitText('s')}{' '}
    </div>
  );
};

export default CountDownClock;
